'use client';

import { useEffect } from 'react';
import { dohIdbSet, type CdnDohRecord } from '@/libs/cdn-sw/idb';
import { CDN_DOH_CACHE_KEY, CDN_DOH_TTL, SW_CDN_DOH_MSG } from '@/libs/cdn-sw/config';

/**
 * DoH 域名同步组件
 *
 * 页面加载后读取 localStorage 中的 DoH 缓存（由 onerror 层或 SW 写入），
 * 若缓存有效则：
 * 1. 将密文记录同步到 IDB（供下次 SW activate 使用）
 * 2. postMessage 密文给 SW（SW 自行解密并更新运行时域名池）
 *
 * 不自行解密，不发起 DoH 查询；查询由 onerror 层和 SW 在重试时按需触发。
 */
export function CdnDohInitializer() {
  useEffect(() => {
    try {
      const raw = localStorage.getItem(CDN_DOH_CACHE_KEY);
      if (!raw) return;
      const rec = JSON.parse(raw) as CdnDohRecord;
      if (typeof rec.ciphertext !== 'string' || Date.now() - rec.ts >= CDN_DOH_TTL) return;

      // 将密文记录同步到 IDB（供 SW 下次 activate 时读取并解密）
      dohIdbSet(rec);

      // postMessage 密文给 SW，SW 自行解密更新 dohDomains
      navigator.serviceWorker?.controller?.postMessage({
        type: SW_CDN_DOH_MSG,
        ciphertext: rec.ciphertext,
        ts: rec.ts,
      });
    } catch { }
  }, []);
  return null;
}
